/**
 * B2B enquiry shortlist — localStorage list + contact form submit (offline follow-up).
 */
(function initB2bEnquiry() {
  const STORAGE_KEY = 'rh_b2b_enquiry_v2';
  const root = document.querySelector('[data-b2b-catalog]');
  if (!root) return;

  /** @type {{ handle: string, variantId: string, title: string, productTitle?: string, variantTitle?: string, sku: string, priceCents: number, priceLabel: string, moq: number, qty: number }[]} */
  let items = loadItems();

  const bar = root.querySelector('[data-b2b-enquiry-bar]');
  const countEl = root.querySelector('[data-b2b-enquiry-count]');
  const openBtn = root.querySelector('[data-b2b-enquiry-open]');
  const submitBtn = root.querySelector('[data-b2b-enquiry-submit]');
  const modal = root.querySelector('[data-b2b-enquiry-modal]');
  const closeBtn = root.querySelector('[data-b2b-enquiry-close]');
  const listEl = root.querySelector('[data-b2b-enquiry-list]');
  const form = root.querySelector('[data-b2b-enquiry-form]');
  const bodyField = root.querySelector('[data-b2b-enquiry-body]');
  const notesField = root.querySelector('[data-b2b-enquiry-notes]');
  const searchInput = root.querySelector('[data-b2b-search]');

  const configEl = root.querySelector('[data-b2b-enquiry-config]');
  /** @type {{ customerEmail?: string, customerName?: string, successRedirect?: string }} */
  let config = {};
  if (configEl) {
    try {
      config = JSON.parse(configEl.textContent || '{}');
    } catch (_e) {
      config = {};
    }
  }

  root.querySelectorAll('[data-b2b-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const row = btn.closest('[data-b2b-row]');
      if (!(row instanceof HTMLElement)) return;
      addFromRow(row);
    });
  });

  root.querySelectorAll('[data-b2b-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      if (!(input instanceof HTMLInputElement)) return;
      const row = input.closest('[data-b2b-row]');
      if (!(row instanceof HTMLElement)) return;
      const moq = moqFromRow(row);
      input.value = String(clampQty(input.value, moq));
    });
  });

  openBtn?.addEventListener('click', () => openModal());
  submitBtn?.addEventListener('click', () => openModal());
  closeBtn?.addEventListener('click', () => closeModal());
  modal?.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  form?.addEventListener('submit', (event) => {
    if (!items.length) {
      event.preventDefault();
      window.alert('Add at least one product to your enquiry list.');
      return;
    }
    const belowMoq = items.find((item) => item.qty < item.moq);
    if (belowMoq) {
      event.preventDefault();
      window.alert(`"${belowMoq.title}" requires a minimum quantity of ${belowMoq.moq}.`);
      return;
    }
    if (!(bodyField instanceof HTMLTextAreaElement)) return;
    bodyField.value = buildEnquiryBody();
  });

  searchInput?.addEventListener('input', () => {
    const q = searchInput.value.trim().toLowerCase();
    root.querySelectorAll('[data-b2b-row]').forEach((row) => {
      if (!(row instanceof HTMLElement)) return;
      const title = (row.dataset.title || '').toLowerCase();
      const productTitle = (row.dataset.productTitle || '').toLowerCase();
      const variantTitle = (row.dataset.variantTitle || '').toLowerCase();
      const sku = (row.dataset.sku || '').toLowerCase();
      const match = !q || title.includes(q) || productTitle.includes(q) || variantTitle.includes(q) || sku.includes(q);
      row.hidden = !match;
    });
  });

  if (config.formPosted) {
    items = [];
    saveItems();
    renderBar();
    openModal();
  }

  renderBar();

  /** @returns {typeof items} */
  function loadItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return parsed.map((item) => ({
        ...item,
        moq: Math.max(1, parseInt(item.moq, 10) || 1),
        qty: Math.max(Math.max(1, parseInt(item.moq, 10) || 1), parseInt(item.qty, 10) || 1),
      }));
    } catch (_e) {
      return [];
    }
  }

  function saveItems() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  /** @param {HTMLElement} row */
  function moqFromRow(row) {
    return Math.max(1, parseInt(row.dataset.moq || '1', 10) || 1);
  }

  /** @param {string|number} qty @param {number} moq */
  function clampQty(qty, moq) {
    return Math.max(moq, parseInt(String(qty), 10) || moq);
  }

  /** @param {HTMLElement} row */
  function addFromRow(row) {
    const qtyInput = row.querySelector('[data-b2b-qty]');
    const moq = moqFromRow(row);
    let qty = moq;
    if (qtyInput instanceof HTMLInputElement) {
      qty = clampQty(qtyInput.value, moq);
      qtyInput.value = String(qty);
    }
    const handle = row.dataset.handle || '';
    const variantId = row.dataset.variantId || '';
    const existing = items.find((item) => item.variantId === variantId && variantId !== '');

    const entry = {
      handle,
      variantId,
      title: row.dataset.title || row.dataset.productTitle || 'Product',
      productTitle: row.dataset.productTitle || '',
      variantTitle: row.dataset.variantTitle || '',
      sku: row.dataset.sku || '',
      priceCents: Number(row.dataset.priceCents || 0),
      priceLabel: row.dataset.priceLabel || '',
      moq,
      qty,
    };

    if (existing) {
      existing.qty = qty;
      existing.moq = moq;
      existing.priceLabel = entry.priceLabel;
      existing.title = entry.title;
    } else {
      items.push(entry);
    }

    saveItems();
    renderBar();
    pulseBar();

    const btn = row.querySelector('[data-b2b-add]');
    if (btn instanceof HTMLButtonElement) {
      const prev = btn.textContent;
      btn.textContent = 'Added';
      btn.disabled = true;
      window.setTimeout(() => {
        btn.textContent = prev;
        btn.disabled = false;
      }, 1200);
    }
  }

  function renderBar() {
    const total = items.reduce((sum, item) => sum + item.qty, 0);
    if (countEl) countEl.textContent = String(total);
    if (bar) bar.hidden = total === 0;
    renderModalList();
  }

  function renderModalList() {
    if (!listEl) return;
    if (!items.length) {
      listEl.innerHTML = '<p class="b2b-enquiry-modal__empty">Your enquiry list is empty. Add products from the table above.</p>';
      return;
    }

    listEl.innerHTML = items
      .map(
        (item, index) => `
        <div class="b2b-enquiry-item" data-index="${index}">
          <div class="b2b-enquiry-item__meta">
            <strong>${escapeHtml(item.title)}</strong>
            ${item.variantTitle && item.productTitle ? `<span class="b2b-enquiry-item__variant">${escapeHtml(item.variantTitle)}</span>` : ''}
            ${item.sku ? `<span class="b2b-enquiry-item__sku">SKU: ${escapeHtml(item.sku)}</span>` : ''}
            <span class="b2b-enquiry-item__price">${escapeHtml(item.priceLabel)} each</span>
            ${item.moq > 1 ? `<span class="b2b-enquiry-item__moq">MOQ: ${item.moq}</span>` : ''}
          </div>
          <div class="b2b-enquiry-item__actions">
            <label>Qty <input type="number" min="${item.moq}" value="${item.qty}" data-enquiry-qty="${index}"></label>
            <button type="button" data-enquiry-remove="${index}" aria-label="Remove">Remove</button>
          </div>
        </div>`
      )
      .join('');

    listEl.querySelectorAll('[data-enquiry-qty]').forEach((input) => {
      input.addEventListener('change', () => {
        const idx = Number(input.getAttribute('data-enquiry-qty'));
        const moq = items[idx]?.moq || 1;
        const val = input instanceof HTMLInputElement ? clampQty(input.value, moq) : moq;
        if (input instanceof HTMLInputElement) input.value = String(val);
        if (items[idx]) items[idx].qty = val;
        saveItems();
        renderBar();
      });
    });

    listEl.querySelectorAll('[data-enquiry-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = Number(btn.getAttribute('data-enquiry-remove'));
        items.splice(idx, 1);
        saveItems();
        renderBar();
      });
    });
  }

  function buildEnquiryBody() {
    const notes = notesField instanceof HTMLTextAreaElement ? notesField.value.trim() : '';
    const lines = [
      'B2B Product Enquiry',
      '',
      `Customer: ${config.customerName || ''}`,
      `Email: ${config.customerEmail || ''}`,
      '',
      'Products interested in:',
    ];

    items.forEach((item, i) => {
      const moqNote = item.moq > 1 ? ` — MOQ: ${item.moq}` : '';
      const variantNote = item.variantId ? ` — Variant ID: ${item.variantId}` : '';
      lines.push(
        `${i + 1}. ${item.title}${item.sku ? ` (SKU: ${item.sku})` : ''}${variantNote} — Qty: ${item.qty}${moqNote} — B2B price: ${item.priceLabel || 'On request'}`
      );
    });

    lines.push('');
    if (notes) {
      lines.push('Notes:');
      lines.push(notes);
    } else {
      lines.push('Please share availability and delivery timeline.');
    }

    return lines.join('\n');
  }

  function openModal() {
    if (!modal) return;
    renderModalList();
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }

  function closeModal() {
    if (!modal) return;
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  function pulseBar() {
    if (!bar) return;
    bar.classList.add('is-pulse');
    window.setTimeout(() => bar.classList.remove('is-pulse'), 400);
  }

  /** @param {string} message */
  function showToast(message) {
    const toast = document.createElement('div');
    toast.className = 'b2b-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  /** @param {string} str */
  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
